import ReactDOM from 'react-dom/client'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

import './index.scss'
import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import reportWebVitals from './reportWebVitals'
import { MsalProvider } from '@azure/msal-react'
import Analytics from './services/analytics'
import { cachePurge } from './util/helpers'
import { reportHandler } from './reportHandler'
import msalInstance from './features/azure-b2c/msalInstance'
import './services/adobe/adobe'

dayjs.extend(relativeTime)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
Analytics.initialize()
cachePurge()

const documentHeight = () => {
  let scale = 1

  // Check if the window height is 720 pixels or less
  if (window.innerHeight <= 720 && window.innerWidth > 1200) {
    scale = 0.75 // 720p is 75% of 1080p
  }

  const root = document.getElementById('root')

  if (root) {
    root.style.transform = `scale(${scale})`
    root.style.transformOrigin = 'top left'
    root.style.width = `${100 / scale}vw`
    root.style.height = `${100 / scale}vh`
  }
  const adjustedHeight = window.innerHeight / scale
  const doc = document.documentElement
  doc.style.setProperty('--doc-height', `${adjustedHeight}px`)
}

window.addEventListener('resize', documentHeight)
documentHeight()

root.render(
  <MsalProvider instance={msalInstance}>
    <App />
  </MsalProvider>,
)

// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(reportHandler)
